<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "Loc ID",
        value: "locID",
        sortable: false
      },
      {
        text: "Description",
        value: "locName",
        sortable: false
      },
      {
        text: "Payroll Type",
        value: "payCode",
        sortable: false
      },
      {
        text: "Tax Rate",
        value: "rateCode",
        sortable: false
      },
      {
        text: "Number of days in a year",
        value: "noOfDays",
        sortable: false
      },
      {
        text: "Tax Withheld Deduction Period",
        value: "contribPayPer",
        sortable: false
      },
      {
        text: "SSS Deduction Period",
        value: "sssPayPer",
        sortable: false
      },
      {
        text: "Pagibig Deduction Period",
        value: "pagPayPer",
        sortable: false
      },
      {
        text: "Philhealth Deduction Period",
        value: "philPayPer",
        sortable: false
      },
      {
        text: "Allowance/Insurance Deduction Period",
        value: "insPayPer",
        sortable: false
      },
      {
        text: "Annualized",
        value: "annualized",
        sortable: false
      },
      {
        text: "Noted By",
        value: "notedBy",
        sortable: false
      },
      {
        text: "Prepared By",
        value: "preparedBy",
        sortable: false
      },
      {
        text: "Reviewed By",
        value: "reviewedBy",
        sortable: false
      },
      {
        text: "Approved By",
        value: "approvedBy",
        sortable: false
      },
      {
        text: "Total Period",
        value: "totalPeriod",
        sortable: false
      },
      {
        text: "Hours in a day",
        value: "hrsInADay",
        sortable: false
      },
      {
        text: "Branch",
        value: "brandCode",
        sortable: false
      },
      {
        text: "Region",
        value: "regionCode",
        sortable: false
      },
      {
        text: "Unit",
        value: "unitCode",
        sortable: false
      },
      {
        text: "Area",
        value: "areaCode",
        sortable: false
      },
      {
        text: "Location",
        value: "locationCode",
        sortable: false
      },
      {
        text: "Pay House",
        value: "subAcctCode",
        sortable: false
      },
      {
        text: "Billing Initial Date",
        value: "billInitDate",
        sortable: false
      },
      {
        text: "Contract Date From",
        value: "billContractDateFrom",
        sortable: false
      },
      {
        text: "Contract Date To",
        value: "billContractDateTo",
        sortable: false
      },
      {
        text: "Billing Period 1 From",
        value: "billPeriod1DateFrom",
        sortable: false
      },
      {
        text: "Billing Period 1 To",
        value: "billPeriod1DateTo",
        sortable: false
      },
      {
        text: "Billing Period 1 Payout",
        value: "billPeriod1PayOut",
        sortable: false
      },
      {
        text: "Billing Period 1",
        value: "billPeriod1Value",
        sortable: false
      },
      {
        text: "Billing Period 2 From",
        value: "billPeriod2DateFrom",
        sortable: false
      },
      {
        text: "Billing Period 2 To",
        value: "billPeriod2DateTo",
        sortable: false
      },
      {
        text: "Billing Period 2 Payout",
        value: "billPeriod2PayOut",
        sortable: false
      },
      {
        text: "Billing Period 2",
        value: "billPeriod2Value",
        sortable: false
      },
      {
        text: "Client Status",
        value: "billClientStatus",
        sortable: false
      },
      {
        text: "Admin Fee",
        value: "billAdminFee",
        sortable: false
      },
      {
        text: "Miscellaneous",
        value: "billMiscellaneous",
        sortable: false
      },
      {
        text: "COLA",
        value: "colaEarnCode",
        sortable: false
      },
      {
        text: "Daily Amount",
        value: "colaDailyAmount",
        sortable: false
      },
      {
        text: "Late",
        value: "colaLate",
        sortable: false
      },
      {
        text: "Undertime",
        value: "colaUnderTime",
        sortable: false
      },
      {
        text: "Absences",
        value: "colaAbsences",
        sortable: false
      },
      {
        text: "Leave",
        value: "colaLeave",
        sortable: false
      },
      {
        text: "With SIL Accural for Billing",
        value: "billWithSIL",
        sortable: false
      },
      {
        text: "No. of Days",
        value: "silNoOfDays",
        sortable: false
      },
      {
        text: "Divisor",
        value: "silDivisor",
        sortable: false
      },
      {
        text: "Terms of payment(day/s)",
        value: "silTermsOfPayment",
        sortable: false
      },
      {
        text: "Vat Rate",
        value: "vatRate",
        sortable: false
      },
      {
        text: "Membership Fee - Deduction Code",
        value: "memberDedCode",
        sortable: false
      },
      {
        text: "Membership Fee - Total Amount",
        value: "memberTotAmount",
        sortable: false
      },
      {
        text: "Membership Fee - Amortization",
        value: "memberAmort",
        sortable: false
      },
      {
        text: "Membership Fee - Period No.",
        value: "memberPeriod",
        sortable: false
      },
      {
        text: "Capital Share - Deduction Code",
        value: "capitalDedCode",
        sortable: false
      },
      {
        text: "Capital Share - Total Amount",
        value: "capitalTotAmount",
        sortable: false
      },
      {
        text: "Capital Share - Amortization",
        value: "capitalAmort",
        sortable: false
      },
      {
        text: "Capital Share - Period No.",
        value: "capitalPeriod",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index &&
          item.mode == "PAYLOC"
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return (
          item.property == "ALL" && item.mode == "PAYLOC" && item.index == index
          //item.mode == "PAYLOC" && item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>